import { Injectable } from '@angular/core';
import { WeightTypes } from '../../enums';

@Injectable({
    providedIn: "root"
})
export class WeightCalculatorService {
    getConvertedWeight(sourceLength: (number | string | null | undefined), sourceType: WeightTypes, targetType: WeightTypes): number {
        if (sourceLength && parseFloat('' + sourceLength) <= 0)
            return 0;

        const source = this.weightTypeMaps.filter(x => x.type === sourceType)[0];
        const target = this.weightTypeMaps.filter(x => x.type === targetType)[0];

        if (!source || !target)
            return 0;

        const val = parseFloat('' + sourceLength);
        const convertedValue = this.round((val * source.value / target.value), 12);

        return convertedValue;
    }

    private round = (value: number, decimal: number): number => {
        return Math.round(Math.pow(10, decimal) * value) / Math.pow(10, decimal);
    }

    private weightTypeMaps: { type: WeightTypes, value: number }[] =
        [
            { type: WeightTypes.Gram, value: 1.00 },
            { type: WeightTypes.MicroGram, value: 0.000001 },
            { type: WeightTypes.MilliGram, value: 0.001 },
            { type: WeightTypes.CentiGram, value: 0.01 },
            { type: WeightTypes.DeciGram, value: 0.1 },
            { type: WeightTypes.DekaGram, value: 10.00 },
            { type: WeightTypes.HectoGram, value: 100.00 },
            { type: WeightTypes.KiloGram, value: 1000.00 },
            { type: WeightTypes.MegagramOrTon, value: 1000000.00 },
            { type: WeightTypes.Grain, value: 0.06479891 },
            { type: WeightTypes.PennyWeight, value: 1.55517384 },
            { type: WeightTypes.Ounce, value: 28.3495 },
            { type: WeightTypes.Pound, value: 453.592 },
            { type: WeightTypes.Carat, value: 0.20 },
            { type: WeightTypes.Gamma, value: 0.000001 }
        ];
}